"use strict";

exports.__esModule = true;
exports.PerformanceParameterValueThumbnail = PerformanceParameterValueThumbnail;
var _react = _interopRequireDefault(require("react"));
var _MeasurementValue = require("../../Measures/MeasurementValue");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Thumbnail for PerformanceParameterValueWidget.
 */
function PerformanceParameterValueThumbnail(_ref) {
  var dataItemIndex = _ref.dataItemIndex,
    hideLabel = _ref.hideLabel,
    _ref$x = _ref.x,
    x = _ref$x === void 0 ? 0 : _ref$x,
    _ref$y = _ref.y,
    y = _ref$y === void 0 ? 0 : _ref$y,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_react["default"].createElement(_MeasurementValue.MeasurementValue, {
    x: x,
    y: y,
    width: width,
    height: height,
    value: dataItemIndex * 17,
    units: "PERCENT",
    label: !hideLabel && "Perf Param"
  });
}